/**
 * A registration's check-in code - what door staff scan (FEA-22, docs/
 * FRONTEND-PLAN.md section 2.5). Shared by the events list and detail page so it
 * looks identical everywhere. Copy affordance mirrors MfaSettings' pattern
 * for one-time secrets (recovery codes): write to the clipboard, flip the
 * button label to a confirmation for two seconds.
 */
import { useState } from 'react';
import { cn, ui } from '../lib/ui';

export default function CheckInCode({ code }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  if (!code) return null;

  return (
    <span className={cn(ui.row, 'items-baseline')}>
      <span>Check-in code:</span>
      <code className="font-mono text-body-l select-all">{code}</code>
      <button type="button" className={ui.btnSecondary} onClick={copy}>
        {copied ? 'Copied ✓' : 'Copy code'}
      </button>
    </span>
  );
}
